import { createSlice } from "@reduxjs/toolkit";
import { FetchDataThunk } from "./data.thunk";

const initialState = {
  data: {},
  loaded: {},
};

export const dataSlice = createSlice({
  name: "Data",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(FetchDataThunk.fulfilled, (state, action) => {
        const { payload } = action;
        if (payload) {
          const key = `${payload.database}.${payload.entity}`;
          state.data = { ...state.data, [key]: payload.data };
          state.loaded = { ...state.loaded, [key]: true };
        }
      })
      .addCase(FetchDataThunk.pending, (state, { meta }) => {
        const key = `${meta.arg.database}.${meta.arg.table}`;
        state.loaded = { ...state.loaded, [key]: false };
      })
      .addCase(FetchDataThunk.rejected, (state, { meta }) => {
        const key = `${meta.arg.database}.${meta.arg.table}`;
        state.loaded = { ...state.loaded, [key]: true };
      });
  },
});

export default dataSlice.reducer;

// selectors
export const dataSelector = (state) => state.Data.data;
export const loadedSelector = (state) => state.Data.loaded;
